window.EkishaTrustIcons = (function () {
  var MAX_SCALE_DESKTOP = 1.55;
  var MAX_LIFT_DESKTOP = 16;
  var RANGE_DESKTOP = 130;

  var MAX_SCALE_MOBILE = 1.45;
  var MAX_LIFT_MOBILE = 12;
  var RANGE_MOBILE = 90;

  function isDesktop() {
    return window.matchMedia('(min-width: 750px)').matches;
  }

  // ---------- DESKTOP: mouse-position dock magnification ----------
  function initDesktopDock(dock, items) {
    function applyEffect(pointerX) {
      items.forEach(function (item) {
        var rect = item.getBoundingClientRect();
        var center = rect.left + rect.width / 2;
        var dist = Math.abs(pointerX - center);
        var influence = Math.max(0, 1 - dist / RANGE_DESKTOP);
        var scale = 1 + influence * (MAX_SCALE_DESKTOP - 1);
        var lift = influence * MAX_LIFT_DESKTOP;
        item.style.transform = 'translateY(' + (-lift) + 'px) scale(' + scale + ')';
        item.style.zIndex = Math.round(scale * 10);
      });
    }
    function reset() {
      items.forEach(function (item) {
        item.style.transform = '';
        item.style.zIndex = '';
      });
    }
    dock.addEventListener('mousemove', function (e) { applyEffect(e.clientX); });
    dock.addEventListener('mouseleave', reset);
  }

  // ---------- MOBILE: real-time finger-drag dock magnification ----------
  // All icons fit in one row (no horizontal scroll), so touchmove purely
  // drives the magnification effect without competing with a swipe-scroll.
  function initMobileDrag(dock, items) {
    var targets = items.map(function (item) {
      return item.querySelector('.eti-scale-target');
    });

    function applyEffect(pointerX) {
      items.forEach(function (item, i) {
        var target = targets[i];
        var rect = item.getBoundingClientRect();
        var center = rect.left + rect.width / 2;
        var dist = Math.abs(pointerX - center);
        var influence = Math.max(0, 1 - dist / RANGE_MOBILE);
        var scale = 1 + influence * (MAX_SCALE_MOBILE - 1);
        var lift = influence * MAX_LIFT_MOBILE;
        target.style.transform = 'translateY(' + (-lift) + 'px) scale(' + scale + ')';
        target.style.zIndex = Math.round(scale * 10);
        if (influence > 0.35) {
          item.classList.add('is-active');
        } else {
          item.classList.remove('is-active');
        }
      });
    }

    function reset() {
      items.forEach(function (item, i) {
        targets[i].style.transform = '';
        targets[i].style.zIndex = '';
        item.classList.remove('is-active');
      });
    }

    dock.addEventListener('touchstart', function (e) {
      if (e.touches && e.touches[0]) applyEffect(e.touches[0].clientX);
    }, { passive: true });

    dock.addEventListener('touchmove', function (e) {
      if (e.touches && e.touches[0]) applyEffect(e.touches[0].clientX);
    }, { passive: true });

    dock.addEventListener('touchend', reset, { passive: true });
    dock.addEventListener('touchcancel', reset, { passive: true });
  }

  function init(dockId) {
    var dock = document.getElementById(dockId);
    if (!dock) return;
    var items = Array.prototype.slice.call(dock.querySelectorAll('.eti-icon-wrap'));

    function clearAll() {
      items.forEach(function (item) {
        item.style.transform = '';
        item.style.zIndex = '';
        item.classList.remove('is-active');
        var target = item.querySelector('.eti-scale-target');
        if (target) {
          target.style.transform = '';
          target.style.zIndex = '';
        }
      });
    }

    var lastState = isDesktop();
    if (lastState) {
      initDesktopDock(dock, items);
    } else {
      initMobileDrag(dock, items);
    }

    // Re-bind if viewport crosses the breakpoint (e.g. device rotation)
    window.addEventListener('resize', function () {
      var nowDesktop = isDesktop();
      if (nowDesktop !== lastState) {
        lastState = nowDesktop;
        clearAll();
        if (nowDesktop) {
          initDesktopDock(dock, items);
        } else {
          initMobileDrag(dock, items);
        }
      }
    });
  }

  return { init: init };
})();